// frontend-mvp/src/utils/upgradeListingNavigation.js

import { buildListingUpgradePayload } from './listingUpgradePayload';

export const persistUpgradePayload = (payload) => {
  try {
    sessionStorage.setItem('listing_upgrade_payload_v1', JSON.stringify(payload));
  } catch (e) {
    // ignore storage errors
  }
};

export const navigateToSingleListingUpgrade = (navigate, productData) => {
  if (!navigate || !productData) return;

  const payload = buildListingUpgradePayload(productData);
  persistUpgradePayload(payload);

  navigate('/dashboard/generate/single', {
    state: {
      isNewListing: false,
      projectName: productData.asin || 'Upgrade Listing',
      initialAsin: productData.asin || '',
      listingUpgradePayload: payload
    }
  });
};


